import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx } from "react/jsx-runtime";
import { useQuery } from '@tanstack/react-query';
import { OrganizationContext } from '@core/organization';
import Registry from '@core/registry';
import { createContext, useContext } from 'react';
import { useDispatch } from 'react-redux';
import { LicenseActions } from '../actions/LicenseActions.js';
import { LicenseInternalHelper } from '../helpers/LicenseInternalHelper.js';
export var LicenseContext = /*#__PURE__*/ createContext({
    query: null
});
export var useLicense = function useLicense() {
    var context = useContext(LicenseContext);
    if (!context || !context.query) {
        throw new Error('useLicense must be used within a LicenseProvider');
    }
    if (!context.query.data) {
        throw new Error('License data is not available');
    }
    return context.query.data;
};
export var LicenseProvider = function LicenseProvider(param) {
    var children = param.children;
    var _organizationCtx_organizationModelQuery_data, _organizationCtx_organizationModelQuery, _organizationCtx_organizationModelQuery1;
    var organizationCtx = useContext(OrganizationContext);
    var orgId = (_organizationCtx_organizationModelQuery = organizationCtx.organizationModelQuery) === null || _organizationCtx_organizationModelQuery === void 0 ? void 0 : (_organizationCtx_organizationModelQuery_data = _organizationCtx_organizationModelQuery.data) === null || _organizationCtx_organizationModelQuery_data === void 0 ? void 0 : _organizationCtx_organizationModelQuery_data.id;
    var dispatch = useDispatch();
    var licenseQuery = useQuery({
        queryKey: [
            'init',
            'license',
            orgId
        ],
        queryFn: function queryFn() {
            return _async_to_generator(function() {
                var license;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                LicenseInternalHelper.fetchFullLicense()
                            ];
                        case 1:
                            license = _state.sent();
                            dispatch(LicenseActions.update(license));
                            Registry.register('license', license);
                            return [
                                2,
                                license
                            ];
                    }
                });
            })();
        },
        retry: false,
        enabled: (_organizationCtx_organizationModelQuery1 = organizationCtx.organizationModelQuery) === null || _organizationCtx_organizationModelQuery1 === void 0 ? void 0 : _organizationCtx_organizationModelQuery1.isSuccess,
        initialData: Registry.get('license', {
            optional: true
        }),
        staleTime: Infinity
    });
    return /*#__PURE__*/ _jsx(LicenseContext.Provider, {
        value: {
            query: licenseQuery
        },
        children: children
    });
};

//# sourceMappingURL=LicenseContext.js.map